import React from 'react';
import type { IActivityFeedProps } from '../types';

export const ActivityFeed = ({ activities }: IActivityFeedProps) => (
    <div className="bg-surface p-4 rounded-lg card fade-in border border-default" style={{ animationDelay: '0.7s' }}>
        <h3 className="text-base xl:text-lg font-bold text-zinc-900 dark:text-white mb-3">Fluxo de Atividade do Negócio</h3>
        <ul className="space-y-4">
            {activities.map((activity, index) => (
                <li key={activity.time} className={`text-sm ${index > 0 ? 'pt-3 border-t border-zinc-200 dark:border-zinc-800' : ''}`}>
                    <p className="text-zinc-700 dark:text-zinc-200" dangerouslySetInnerHTML={{ __html: activity.text }}></p>
                    <p className="text-xs text-zinc-400 dark:text-zinc-500 mt-1">{activity.time}</p>
                </li>
            ))}
        </ul>
    </div>
);
